import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const FeaturedProductApi = createApi({
    reducerPath:"FeaturedProductApi",
    baseQuery: fetchBaseQuery({
        baseUrl:import.meta.env.VITE_API_URL,
        prepareHeaders:(headers)=>{
            const token = localStorage.getItem('_at') || null
            if(token){
                headers.set("Authorization", "Bearer "+token)
            }
        }
    }),
    tagTypes:['FeaturedProduct'],
    // Keep unused data for 10 minutes for better performance
    keepUnusedDataFor: 600,
    // Refetch on reconnect for better UX
    refetchOnReconnect: true,
    // Refetch on focus for fresh data when user returns
    refetchOnFocus: true,
    endpoints:(builder)=>({
        listAll: builder.query({            
            query: ({ page = 1, limit = 10, search = '' }) => 
              `/featured_product?page=${page}&limit=${limit}&search=${search}`,
            providesTags:['FeaturedProduct'],
          }),
        create:builder.mutation({
            query:(formData)=> ({
                url: "/featured_product",
                body:formData,
                method:"POST",
                headers:()=>([
                    {"Content-Type":"multipart/form-data"}
                ])
            }),
            invalidatesTags:['FeaturedProduct'],
        }),
        listForHome: builder.query({            
            query: () => '/featured_product/list',
            // Cache home collections for 30 minutes since they change less frequently
            keepUnusedDataFor: 1800,
            // Provide more specific tags for better cache management
            providesTags: (result) => 
                result?.result?.data
                    ? [
                        ...result.result.data.map(({ _id }) => ({ type: 'FeaturedProduct', id: _id })),
                        { type: 'FeaturedProduct', id: 'HOME_LIST' },
                    ]
                    : [{ type: 'FeaturedProduct', id: 'HOME_LIST' }],
            // Transform response for better performance
            transformResponse: (response) => ({
                ...response,
                cachedAt: Date.now(),
                // Pre-process data for faster rendering
                processedData: response?.result?.data?.map(item => ({
                    ...item,
                    imageUrl: item.desktopImage || item.mobileImage
                }))
            }),
          }),
        update:builder.mutation({
            query:({id,payload})=>({
                url: `/featured_product/${id}`,
                body:payload,
                method:'PUT',
                headers:()=>([
                    {"Content-Type" :"multipart/form-data"}
                ])
            }),
            invalidatesTags:['FeaturedProduct'],
        }),
        showById:builder.query({
            query:(id)=>`/featured_product/${id}`
        }),
        delete:builder.mutation({
            query:(id)=>({
                url:`/featured_product/${id}`,
                method:"DELETE"
            }),
            invalidatesTags:['FeaturedProduct'],
        }),
        // Add prefetch methods for better performance
        prefetchHome: builder.query({
            query: () => "/featured_product/list",
            keepUnusedDataFor: 1800,
            providesTags: [{ type: 'FeaturedProduct', id: 'HOME_PREFETCH' }],
        }),
    })
})
export const {useShowByIdQuery, useDeleteMutation, useUpdateMutation, useListForHomeQuery, useCreateMutation, useListAllQuery, usePrefetchHomeQuery, useLazyListForHomeQuery, } = FeaturedProductApi